(ns frontend.view.modals.processing.view
  (:require
   [common.localization :as loc]
   [frontend.view.modals.components.processing-layer :as processing-layer]
   [frontend.view.modals.components.error-layer :as error-layer]
   [frontend.view.modals.components.success-layer :as success-layer]
   [ui.components.modal.view :as modal]
   [ui.color :as c]))

(defonce modal-key :processing-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [start-process! title success-text]} props]
    (swap! state assoc :process/status :process.status/processing)
    (js/setTimeout #(start-process! state) 100)
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [start-process! title success-text]} props
            status (:process/status @state)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :color         (when (= :process.status/failed (:process/status @state))
                           ::c/danger)
          :backdrop      "static"
          :close-button? true}
         title
         (case status
           :process.status/success (success-layer/view state success-text)
           :process.status/failed (error-layer/generic-error state)
           :process.status/processing (processing-layer/view state)
           (str "Unknown result " status)
         )
         (when (some #{status} [:process.status/success :process.status/failed])
           [modal/left-single-button
            nil
            false
            close-modal!
            (loc/tr :close)])]))))
